<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-layout column>
          <v-data-table
            dense
            :headers="headers"
            :items="directPlacementPaymentList"
            :items-per-page=5
          >
            <template v-slot:item.amount="{ item }">
              <div :class="{'red--text': item.amount < 0}">
                {{item.amount | currency}}
              </div>
            </template>
            <template v-slot:item.receivedAt="{ item }">
              {{item.receivedAt | formatDate}}
            </template>
            <template v-slot:item.actions="{ item }" v-if="!hideActionsColumn">
              <v-btn
                class="mx-1 my-1"
                color="primary"
                outlined
                @click="editPayment(item.id)"
              >
                <v-icon color="primary">edit</v-icon>
              </v-btn>
              <v-btn
                v-if="isAdmin"
                class="mx-1 my-1"
                color="red"
                outlined
                @click="deletePaymentHandler(item)"
              >
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <hr class="mt-4">
        </v-layout>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" md="2" class="text-end mr-10">
        TOTAL RECEIVED: {{ totalPaymentsAmount | currency }}
      </v-col>
      <v-col cols="12" md="2" class="text-end mr-10">
        REMAINING: {{ amountRemaining | currency }}
      </v-col>
    </v-row>
    <ConfirmationModal
      :title="'Delete Confirmation'"
      :contentText="'Are you sure you want to delete the selected payment?'"
      :toolbarColor="'primary'"
      @cancel-click="() => {
        this.showDeleteConfirmationDialog = false
        this.paymentIdToDelete = null
      }"
      @ok-click="confirmDelete"
      :showModal="showDeleteConfirmationDialog"
    ></ConfirmationModal>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { userIsAdmin } from '@/lib/authentication'
import { ConfirmationModal } from '@/components/dialogs'
import { mapActions } from 'vuex'

export default {
  components: {
    ConfirmationModal
  },
  props: [
    'hideActionsColumn',
    'netFee'
  ],
  data: () => ({
    headers: [
      {
        text: 'Received On',
        sortable: true,
        value: 'receivedAt',
        align: 'center',
        width: '20%'
      },
      { text: 'Notes',
        sortable: false,
        value: 'paymentNotes',
        width: '40%'
      },
      {
        text: 'Amount',
        sortable: true,
        value: 'amount',
        align: 'right',
        width: '20%'
      },
      {
        text: '',
        align: 'right',
        sortable: false,
        value: 'actions',
        width: '20%'
      }
    ],
    showDeleteConfirmationDialog: false,
    paymentIdToDelete: null
  }),
  computed: {
    ...mapFields('directPlacementPayments', [
      'directPlacementPaymentList'
    ]),
    totalPaymentsAmount () {
      return this.directPlacementPaymentList.reduce((total, item) => {
        return total + parseFloat(item.amount)
      }, 0)
    },
    amountRemaining () {
      return this.netFee - this.totalPaymentsAmount
    },
    isAdmin () {
      return userIsAdmin()
    }
  },
  methods: {
    ...mapActions('directPlacementPayment', [
      'deleteDirectPlacementPayment'
    ]),
    editPayment (paymentId) {
      this.$emit('editPayment', paymentId)
    },
    deletePaymentHandler (item) {
      this.paymentIdToDelete = item.id
      this.showDeleteConfirmationDialog = true
    },
    confirmDelete () {
      this.deleteDirectPlacementPayment(this.paymentIdToDelete).then(() => {
        this.$emit('paymentDeleted')
      })
      this.showDeleteConfirmationDialog = false
    }
  }
}
</script>
